import React from 'react';
import { Link } from 'react-scroll'; // Premium scroll
import { MapPin, Phone, Mail, ShieldCheck } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const scrollProps = { smooth: true, offset: -80, duration: 600 };

  return (
    <footer className="custom-footer">
      <div className="footer-content">
        <div className="footer-brand">
          <h2><span style={{ color: "var(--acurio-teal)" }}>▲</span> Acurio</h2>
          <p>A modular, secure, cloud-based dental practice platform designed to centralize core operational workflows.</p>
        </div>
        
        <div className="footer-links">
          <h3>Modules</h3>
          <ul>
            <li><Link to="home" {...scrollProps} style={{cursor:'pointer'}}>Kryptic Vault</Link></li>
            <li><Link to="home" {...scrollProps} style={{cursor:'pointer'}}>Patient AR</Link></li>
            <li><Link to="home" {...scrollProps} style={{cursor:'pointer'}}>Digital Intake</Link></li>
            <li><Link to="home" {...scrollProps} style={{cursor:'pointer'}}>Analytics & BI</Link></li>
          </ul>
        </div>

        <div className="footer-links">
          <h3>Contact Info</h3>
          <ul className="footer-contact-list">
            <li><MapPin size={18} className="footer-icon" /><span>Charlotte 28277</span></li>
            <li><Phone size={18} className="footer-icon" /><span>+1 (800) 123-4567</span></li>
          </ul>
        </div>

        <div className="footer-links">
          <h3>Company & Legal</h3>
          <ul>
            <li><Link to="about" {...scrollProps} style={{cursor:'pointer'}}>About Us</Link></li>
            <li><Link to="contact" {...scrollProps} style={{cursor:'pointer'}}>Contact</Link></li>
            <li><Link to="privacy" {...scrollProps} style={{cursor:'pointer'}}>Privacy Policy</Link></li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="footer-bottom-flex">
          <p>&copy; {new Date().getFullYear()} Acurio.io. HIPAA-Aligned Data Handling.</p>
          <div className="hipaa-badge">
             <ShieldCheck size={14} style={{ marginRight: '5px' }} />
             HIPAA COMPLIANT
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;